import BrowserDetection from './browserDetection.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace BrowserDetection
 */
window.BrowserCompatibility = function (supportedBrowsers) {

    var DISMISSABLE_IE_VERSION = 8;
    var IS_COMPATIBLE_KEY = "dismissBrowserWarning";


    if (!checkBrowser()) {
        if (!checkCompatibleKey()) {
            checkIE8();
            showModal();
        }
        // switch event handling given jquery compatibility issue.  If jquery issue is resolved, we should switch to just the jquery way.
        handleJqueryCompatibilityIssue();
    }


    // BEGIN UTIL FUNCTIONS
    function checkBrowser() {
        var isSupported = false;
        for (var i = 0; i < supportedBrowsers.length; i++) {
            var browserType = supportedBrowsers[i].split(":");
            if (browserType.length === 2 && browserType[0] === BrowserDetection.browserName) {
                if (browserType[1] == BrowserDetection.browserVersion || browserType[1] === "*") {
                    isSupported = true;
                }
            }
        }
        if (BrowserDetection.isModernDefault) {
            isSupported = true;
        }
        return isSupported;
    }

    function checkCompatibleKey() {
        return localStorage.getItem(IS_COMPATIBLE_KEY);
    }

    function storeCompatibleKey(val) {
        localStorage.setItem(IS_COMPATIBLE_KEY, val);
    }

    function onClose(e) {
        storeCompatibleKey(true);
        hideModal();
        //e.preventDefault(); <-- why did we need this anyway?
    }

    //We found that the version of jquery we are using is not compatible with IE 6. Since this needs to work with older browsers we avoided using jquery.

    function handleJqueryCompatibilityIssue() {
        var closeElement = document.querySelectorAll(".close")[0];

        if (window.addEventListener) { // modern browsers including IE9+
            closeElement.addEventListener('click', onClose, false);
        } else if (window.attachEvent) { // IE8 and below
            closeElement.attachEvent('onclick', onClose);
        } else {
            closeElement['onclick'] = fn;
        }
    }

    function hideModal() {
        var BC = document.querySelectorAll('.browserCompatibilityContainer')[0];
        BC.className += ' hidden';
        BC.querySelectorAll('.scrim')[0].className += ' hidden';
    }

    function showModal() {
        document.getElementById("browserWarning").className = "modal";
        document.querySelector(".scrim").className = "scrim";
    }

    function checkIE8() {
        if (BrowserDetection.isIE() && BrowserDetection.IECompatabilityVersion() <= DISMISSABLE_IE_VERSION) {
            var compatibility = document.querySelectorAll('.browserCompatibilityContainer')[0];
            compatibility.className += ' ext-ie8';
        }
    }

};

export default window.BrowserCompatibility;






//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/browserCompatibility.js
// module id = 286
// module chunks = 0